<template>
  <EmdPanel>
    <EmdPanelSection :title="$t('recipients.create.identification')">
      <EmdFormGroup
        :label="$t('recipients.create.type')"
        :required="canEdit"
      >
        <div
          v-if="canEdit"
          class="eu-mt_2"
        >
          <EmdRadio
            :label="$t('recipients.create.type_individual')"
            id="recipient_type_individual"
            name="recipient_type"
            value="individual"
            v-model="recipient.type"
            @change="handleChangeType"
            class="eu-mr_4 eu-mb_2"
          />

          <EmdRadio
            :label="$t('recipients.create.type_company')"
            id="recipient_type_company"
            name="recipient_type"
            value="corporation"
            v-model="recipient.type"
            @change="handleChangeType"
            class="eu-mb_2"
          />
        </div>
        <div
          v-else
          class="eu-display_flex eu-column"
        >
          <span>{{ recipientType }}</span>
        </div>
      </EmdFormGroup>
      <DocumentInput
        :recipient="recipient"
        :canEdit="canEdit"
      />
    </EmdPanelSection>
    <EmdPanelSection :title="$t('company-data')">
      <CompanyNameInput
        :recipient="recipient"
        :canEdit="canEdit"
      />
      <EmailInput
        :recipient="recipient"
        :canEdit="canEdit"
      />
    </EmdPanelSection>
    <EmdPanelSection
      v-for="(partner, index) in recipient.managing_partners"
      :title="$t('managing-partner', { number: index + 1 })"
      :key="index"
    >
      <EmailInput
        :recipient="partner"
        :canEdit="canEdit"
      />
      <NameInput
        :recipient="partner"
        :canEdit="canEdit"
      />
      <DocumentInput
        :recipient="partner"
        :canEdit="canEdit"
      />
    </EmdPanelSection>
  </EmdPanel>
</template>

<script>
import {
  EmdPanel,
  EmdPanelSection,
  EmdFormGroup,
  EmdRadio
} from 'emerald-vue/src/components'
import {
  EmailInput,
  NameInput,
  DocumentInput,
  CompanyNameInput
} from './FormFields'
import { getState, feedbacks } from '@/utils/form.utils'

export default {
  name: 'RecipientBasicData',
  components: {
    EmdPanel,
    EmdPanelSection,
    EmdFormGroup,
    EmailInput,
    NameInput,
    EmdRadio,
    DocumentInput,
    CompanyNameInput
  },
  data: () => ({
    getState,
    feedbacks
  }),
  props: {
    recipient: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  computed: {
    isIndividual () {
      return this.recipient.type === 'individual'
    },
    recipientType () {
      return this.isIndividual
        ? this.$t('recipients.create.type_individual')
        : this.$t('recipients.create.type_company')
    }
  }
}
</script>

<i18n>
  {
    "pt-BR":{
      "company-data": "Dados da empresa",
      "managing-partner": "Sócio {number}"
    },
    "en-US":{
      "company-data": "Company data",
      "managing-partner": "Managing partner {number}"
    }
  }
</i18n>
